<template>
  unAuth layout:
  <slot></slot>
</template>